import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { USER_ROLES } from '../../models/dataModels';

export default function ProtectedRoute({ children, requiredRole }) {
  const { currentUser, userProfile, hasPermission } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Only check permissions if a specific role is required
  // If no role is required, any authenticated user can access
  if (requiredRole && !hasPermission(requiredRole)) {
    // Redirect to home if not authorized
    return <Navigate to="/" replace />;
  }

  return children;
}
